import { useTranslation } from 'react-i18next';
import { useTypedParams } from 'react-router-typesafe-routes';
import GroupJoinApplicationListItem from '@/components/contacts/application-list/group-join-application-list-item';
import EmptyLayout from '@/components/layouts/empty-layout';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useGroupJoinApplications from '@/hooks/groups/use-group-join-applications';
import ROUTES from '@/routes';

export default function GroupApplicationsRoute() {
  const { t } = useTranslation();

  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.APPLICATIONS);
  const { groupJoinApplications, isLoading } = useGroupJoinApplications(groupId);

  return (
    <PageLayout
      title={t('conversation.setting.group.application.title')}
      headerConfig={{
        navigateBack: true,
      }}>
      <div className='mx-5'>
        <LoadingLayout promise={isLoading}>
          {() =>
            groupJoinApplications.length > 0 ? (
              <ul className='flex w-full flex-col items-stretch gap-6 desktop:overflow-y-auto'>
                {groupJoinApplications.map((application) => (
                  <li
                    key={application.id}
                    className='w-full'>
                    <GroupJoinApplicationListItem
                      groupId={groupId}
                      application={application}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              <EmptyLayout
                className='flex'
                label='contact.applications.empty'
              />
            )
          }
        </LoadingLayout>
      </div>
    </PageLayout>
  );
}
